// components/Footer.jsx
import React from "react";
import { Box, Typography, Link as MUILink } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../assets/logo-full.png";

const Footer = () => {
  const { t } = useTranslation("Footer");

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#f9f9f9",
        mt: 8,
        pt: 6,
        pb: 3,
        px: 3,
        borderTop: "1px solid #e0e0e0",
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      {/* Contenu principal */}
      <Box
        sx={{
          maxWidth: "1200px",
          mx: "auto",
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" },
          gap: 4,
        }}
      >
        {/* Logo + slogan */}
        <Box 
          sx={{ 
            textAlign: { xs: "center", md: "left" },
            maxWidth: 240
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="Safe for Bike"
            sx={{ width: 220, height: "auto", mb: 1 }}
          />
          <Typography sx={{ color: "#555", fontSize: "0.9rem", pl: 2 }}>
            {t("tagline")}
          </Typography>
        </Box>

        {/* Navigation */}
        <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
          <Typography component="h3" sx={{ fontWeight: 800, mb: 1, color: "#000" }}>
            {t("navigation.title")}
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1, alignItems: { xs: "center", md: "flex-start" } }}>
            <MUILink component={RouterLink} to="/garanties" underline="hover" sx={{ color: "#555" }}>
              {t("navigation.links.guarantees")}
            </MUILink>
            <MUILink component={RouterLink} to="/partenaires" underline="hover" sx={{ color: "#555" }}>
              {t("navigation.links.partners")}
            </MUILink>
            <MUILink component={RouterLink} to="/qui-sommes-nous" underline="hover" sx={{ color: "#555" }}>
              {t("navigation.links.about")}
            </MUILink>
            <MUILink component={RouterLink} to="/parcours-client" underline="hover" sx={{ color: "#555" }}>
              {t("navigation.links.subscribe")}
            </MUILink>
          </Box>
        </Box>

        {/* Liens légaux */}
        <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
          <Typography component="h3" sx={{ fontWeight: 800, mb: 1, color: "#000" }}>
            {t("legal.title")}
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1, alignItems: { xs: "center", md: "flex-start" } }}>
            <MUILink component={RouterLink} to="/mentions-legales" underline="hover" sx={{ color: "#555" }}>
              {t("legal.links.legalNotice")}
            </MUILink>
            <MUILink component={RouterLink} to="/conditions-generales" underline="hover" sx={{ color: "#555" }}>
              {t("legal.links.terms")}
            </MUILink>
            <MUILink component={RouterLink} to="/politique-de-confidentialite" underline="hover" sx={{ color: "#555" }}>
              {t("legal.links.privacy")}
            </MUILink>
            <MUILink component={RouterLink} to="/politique-de-cookies" underline="hover" sx={{ color: "#555" }}>
              {t("legal.links.cookies")}
            </MUILink>
          </Box>
        </Box>
      </Box>

      {/* Barre inférieure */}
      <Box
        sx={{
          maxWidth: "1200px",
          mx: "auto",
          mt: 4,
          pt: 2,
          borderTop: "1px solid #e0e0e0",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Typography sx={{ fontSize: "0.85rem", color: "#777" }}>
          © {new Date().getFullYear()} Safe for Bike. {t("copyright")}
        </Typography>

        <Typography sx={{ fontSize: "0.85rem", color: "#777" }}>
          {t("contact.prefix")}{" "}
          <MUILink href="mailto:contact@safeforbike.com" sx={{ color: "#449F2D" }}>
            contact@safeforbike.com
          </MUILink>
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;